import { styled } from 'styled-components';

export const EditTitle = styled.div`
  align-self: center;
  margin-top: 27px;
  font-size: 18px;
  font-weight: 400;
  line-height: 35px;
  color: var(--HScan_Dark_Blue, #16172c);
`;

export const MobileEditTitle = styled.div`
  align-self: flex-start;
  margin-top: 44px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--HScan_Light_Blue, #2e5be0);
`;

export const EditDescription = styled.div<{ $marginTop?: string }>`
  width: 483px;
  max-width: 100%;
  margin-top: ${p => p.$marginTop ?? 'auto'};
  text-align: center;
  font: Poppins;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: var(--HPACS_Text_Light_Grey, #a3a6ab);
  & > strong {
    font-weight: 700;
    display: inline;
  }
`;

export const EditInputField = styled.div<{ $marginTop?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 405px;
  max-width: 100%;
  margin-top: ${p => p.$marginTop ?? 'auto'};
  gap: 7px;
`;

export const EditInputContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 11px 10px 12px 18px;
  align-items: center;
  justify-content: space-between;
  border: 0.864023px solid #e7e7e7;
  box-shadow: 0px 0.8px 7px rgba(103, 103, 103, 0.03);
  border-radius: 8px;
`;

export const EditInputLabel = styled.div<{ $letterSpacing?: string }>`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #5a6473;
  letter-spacing: ${p => p.$letterSpacing ?? 'normal'};
  word-break: keep-all;

  &::after {
    content: ':';
  }
`;

export const EditInputText = styled.input<{
  type?: string;
}>`
  type: ${p => p.type ?? 'text'};
  box-sizing: border-box;
  width: 265px;
  padding: 7px;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: var(--HPACS_Text_Light_Grey, #a3a6ab);
  border: 1px solid #e7e7e7;
  border-radius: 4px;

  ${p =>
    p.theme.isMobile &&
    `
    max-width: 200px;
  `}
`;

export const CertificationButton = styled.button`
  display: flex;
  width: 100%;
  height: 37px;
  padding: 8px 0px;
  gap: 10px;
  isolation: isolate;
  flex: none;
  order: 2;
  flex-grow: 0;
  font-size: 14px;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--HScan_Light_Blue, #2e5be0);
  border-radius: 4px;
  color: var(--HScan_Light_Blue, #2e5be0);
  background: white;
  cursor: pointer;
`;

export const ErrorMessage = styled.div`
  width: 405px;
  max-width: 100%;
  height: 18px;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #ff5656;
`;
